@if (isLoading()) {
  <div class="spinner-container">
    <mat-progress-spinner [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
  </div>
} @else {
<div class="container">
    @if(areRejectedActivities()) {
      <div class="rejected-banner">
        <span>The inspection timesheet is in “Rejected” status. Some activities have been returned. Please review them and resubmit.</span>
        @if (isSubmitting()) {
          <mat-progress-spinner [diameter]="24" color="primary" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <button
            class="rejected-button"
            (click)="submit()"
            matButton="filled"
          >
            SUBMIT
          </button>
        }
      </div>
    } @else {
      @if(arePendingActivities()) {
      <div class="submission-banner">
        <span>Inspection Timesheet is in “Pending” Status. Please enter and submit your Activities.</span>
        @if (isSubmitting()) {
          <mat-progress-spinner [diameter]="24" color="primary" mode="indeterminate"></mat-progress-spinner>
        } @else {
          <button
            class="submit-button"
            (click)="submit()"
            matButton="filled"
          >
            SUBMIT
          </button>
        }
      </div>
      } @else {
        @if((areNoActivities())) {
          <div class="submission-banner">
            <span>Inspection Timesheet is in “Pending” Status. Please enter and submit your Activities.</span>
            <button
              class="submit-button"
              (click)="submit()"
              [disabled]="submitButtonDisabled()"
              matButton="filled"
            >
            SUBMIT
            </button>
          </div>
        } @else {
          @if(allActivitiesApproved()) {
            @if(inspectionTimeSheetState() != InspectionTimeManagementState.Approved) {
              <div class="approved-banner">
                <span>Your Timesheet Activities has been Approved. Pending for other Inspectors Activities to be Approved.</span> 
              </div>
            } @else {
              <div class="approved-banner">
                <span>Inspection Timesheet has been Approved.</span> 
              </div>
            }
          } @else {
            @if(allActivitiesSubmitted()) {
              <div class="submitted-banner">
                <span>Inspection Timesheet is in “Submitted” Status. Activities are awaiting for Approval.</span>              
              </div>
            }
          }
        }
      }   
    }        
  <div class="secondary-container">
    <button
      class="add-button"
      (click)="addNewTimesheetActivity()"
      [disabled]="addNewActivityButtonDisabled()"
      matButton="filled"
      color="primary"
    >
      <mat-icon>add</mat-icon>
      ADD NEW EVENT
    </button>    
  </div>

  <div class="table-container">
    <table
      #matTable
      [dataSource]="datasource()"
      mat-table
    >
      <ng-container matColumnDef="checkbox">
        <th *matHeaderCellDef mat-header-cell>
        </th>
        <td *matCellDef="let element" mat-cell>
          <mat-checkbox
              [disabled]="
                element.status === TimesheetActivityStatus.Rejected ||
                element.status === TimesheetActivityStatus.Approved ||
                element.status === TimesheetActivityStatus.Submitted ||
                (!selection.isSelected(element) && selection.selected.length >= 10)
              "
            [checked]="selection.isSelected(element)"
            (keyPress)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (keydown.space)="
              $event.stopPropagation(); selection.toggle(element)
            "
            (change)="$event ? selection.toggle(element) : null"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th
          class="header-label"
          *matHeaderCellDef
          mat-header-cell
        >
          Date
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                TimesheetActivityError.InvalidDateDueToTimeOff,
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.date"
              [disabled]="isRowLocked(element)"
              [matDatepicker]="picker"
              [matDatepickerFilter]="filterFutureDates"
              (dateChange)="
                changeAllSelectedRows(element, 'date');
                checkValidityAndSave(i, 'date')
              "
              matInput
            />
            <mat-datepicker-toggle
              [for]="picker"
              matIconSuffix
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="activity">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Activity</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="element.activityId"
              [disabled]="isRowLocked(element)"
              (selectionChange)="
                matchActivityIdWithActivityName(element);
                changeAllSelectedRows(element, 'activityId');
                checkValidityAndSave(i, 'activityId')
              "
            >
              @for (activity of activities(); track activity.id) {
                <mat-option [value]="activity.id">{{
                  activity.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="itemType">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Item Type
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select
              [(ngModel)]="element.itemType"
              [disabled]="isRowLocked(element)"
              (selectionChange)="
                changeAllSelectedRows(element, 'itemType');
                checkValidityAndSave(i, 'itemType')
              "
            >
              @for (itemType of itemTypes(); track itemType.id) {
                <mat-option [value]="itemType.id">{{
                  itemType.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOfItems">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Nu. of<br>Items
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.numberOfItems"
              [disabled]="isRowLocked(element)"
              [style.text-align]="'right'"
              [maxLength]="6"
              (keypress)="onlyNumbers($event)"
              (input)="changeAllSelectedRows(element, 'numberOfItems')"
              (blur)="checkValidityAndSave(i, 'numberOfItems')"
              (paste)="preventPaste($event)"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dayShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Day Shift<br>Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                  TimesheetActivityError.InvalidHoursMoreThanAllowed &&
                greaterThanAllowedShift(element.dayShiftHours),
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.dayShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'dayShiftHours');
                changeAllSelectedRows(element, 'dayShiftHours');
                checkValidityAndSave(i, 'dayShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="nightShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Night Shift<br>Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field
            [ngClass]="{
              'error-color':
                element.validityError ==
                  TimesheetActivityError.InvalidHoursMoreThanAllowed &&
                greaterThanAllowedShift(element.nightShiftHours),
            }"
            appearance="outline"
            subscriptSizing="dynamic"
          >
            <input
              [(ngModel)]="element.nightShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'nightShiftHours');
                changeAllSelectedRows(element, 'nightShiftHours');
                checkValidityAndSave(i, 'nightShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="overtimeHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Overtime<br>Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.overtimeHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'overtimeHours');
                changeAllSelectedRows(element, 'overtimeHours');
                checkValidityAndSave(i, 'overtimeHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="doubleShiftHours">
        <th class="header-label" *matHeaderCellDef mat-header-cell>
          Double Shift<br>Hours
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.doubleShiftHours"
              [disabled]="isRowLocked(element)"
              (keypress)="onlyNumbers($event)"
              (blur)="
                formatTimeString(element, 'doubleShiftHours');
                changeAllSelectedRows(element, 'doubleShiftHours');
                checkValidityAndSave(i, 'doubleShiftHours')
              "
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [value]="getStatusLabel(element.status)"
              readonly
              [disabled]="true"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="remarks">
        <th class="header-label" *matHeaderCellDef mat-header-cell>Remarks</th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              [(ngModel)]="element.remarks"
              [disabled]="isRowLocked(element)"
              [maxlength]="100"
              (input)="changeAllSelectedRows(element, 'remarks')"
              (blur)="checkValidityAndSave(i, 'remarks')"
              matTooltip="{{ element.remarks }}"
              matInput
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th class="header-label" *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell>
          <button [matMenuTriggerFor]="menu" [disabled]="actionButtonDisabled(element)" matIconButton>
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              class="action-button"
              [disabled]="element.id === '' || selection.isSelected(element)"
              (click)="cloneTimesheetActivity(element)"
              mat-menu-item
            >
              <mat-icon class="action-icon-size">content_copy</mat-icon>
              <span class="action-size">Clone</span>
            </button>
            <button
              class="action-button"
              [disabled]="element.id === '' || isRowLocked(element)"
              (click)="openDeleteConfirmDialog(element)"
              mat-menu-item
            >
              <mat-icon class="action-icon-size">delete</mat-icon>
              <span class="action-size delete-action">Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="displayedColumns(); sticky: true"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns()"
        [ngClass]="{
          'row-not-valid': !row.isValid,
          'row-selected': row.isValid && selection.selected.includes(row),
        }"
        mat-row
      ></tr>
    </table>
  </div>
</div>
}
